(() => {
  if (window.vitalaJourneyScrollInstalled) return;
  window.vitalaJourneyScrollInstalled = true;
  let roots = [];
  let pending = false;
  function update() {
    pending = false;
    const trigger = window.innerHeight * 0.65;
    roots = roots.filter(root => root.isConnected);
    roots.forEach(root => {
      root.querySelectorAll('.vj-step').forEach(step => {
        const rect = step.getBoundingClientRect();
        const start = rect.top + 14;
        const progress = Math.max(0, Math.min(100, (trigger - start) / Math.max(1, rect.height) * 100));
        step.classList.toggle('is-reached', start <= trigger);
        step.style.setProperty('--vj-progress', `${progress}%`);
      });
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  function discover() {
    roots = Array.from(document.querySelectorAll('.vj'));
    update();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', discover);
  window.addEventListener('load', discover);
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
  else discover();
})();
